const F1_IMG =
  "https://customer-assets-lqy194kg.emergentagent.net/job_elite-connect-41/artifacts/6qh3fzwr_A33CD683-086F-4DB4-8845-6753BDD1F42D.JPG";

const services = [
  {
    num: "01",
    title: "Team Partnerships",
    copy: "Connecting brands with commercial opportunities across Formula One teams.",
    testid: "f1-card-1",
  },
  {
    num: "02",
    title: "Brand Entry Strategy",
    copy: "Helping companies understand where and how they should enter Formula One.",
    testid: "f1-card-2",
  },
  {
    num: "03",
    title: "Partnership Activation",
    copy: "Building concepts that extend partnerships beyond logo placement.",
    testid: "f1-card-3",
  },
  {
    num: "04",
    title: "Race Weekend Experiences",
    copy: "Creating opportunities around hospitality, events and key Grand Prix markets.",
    testid: "f1-card-4",
  },
];

export default function FormulaOneSection() {
  return (
    <section id="formula-one" className="bg-[#0A0A0A] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-28 lg:py-36">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-end mb-16">
          <div>
            <p className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#F7F6F2] mb-6">
              01 — Discipline
            </p>
            <h2
              data-testid="f1-section-header"
              className="font-heading font-light uppercase tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl"
            >
              Formula One
            </h2>
          </div>
          <p className="text-base sm:text-lg font-light text-neutral-400 leading-relaxed max-w-xl">
            Formula One provides brands with access to one of the world's most
            international, commercially powerful and culturally relevant
            sporting platforms. QUALIVE works with brands seeking opportunities
            across teams, race weekends, hospitality, digital activation and
            wider motorsport partnerships.
          </p>
        </div>

        <div className="relative overflow-hidden mb-16 grain">
          <img
            src={F1_IMG}
            alt="Racing machinery detail in the pit lane"
            className="w-full aspect-[21/9] object-cover"
          />
          <div className="absolute inset-0 bg-black/20" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-white/10">
          {services.map((s) => (
            <div
              key={s.num}
              data-testid={s.testid}
              className="group border-b border-r border-white/10 p-8 lg:p-10 hover:border-b-[#F7F6F2] transition-colors duration-200"
            >
              <span className="font-mono-tech text-xs text-[#F7F6F2] tracking-[0.2em]">
                {s.num}
              </span>
              <h3 className="font-heading font-medium text-xl mt-6 mb-4 tracking-tight">
                {s.title}
              </h3>
              <p className="text-sm text-neutral-400 leading-relaxed font-light">
                {s.copy}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
